/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { InfoItem } from '@molecules';
import { pluralize } from '@utils';
import { getImage } from '@utils/media';
import { useMedia } from '@api/hooks';

const CarouselItem = ({ module: { content }, errors }) => {
  const { media } = useMedia(getImage(content.slides?.[0]));

  return (
    <InfoItem.WithError
      error={errors}
      size="large"
      image={media.src}
      description={pluralize(content.slides?.length, 'slide')}
    >
      Scroll News Panel
    </InfoItem.WithError>
  );
};

export default CarouselItem;
